import Carousel from "./components/Carousel";
import CarouselIntro from "./components/CarouselIntro";
import CarouselItem from "./components/CarouselItem";
import rehydrator from "./Carousel.rehydrator";
Carousel.Intro = CarouselIntro;
Carousel.Item = CarouselItem;
Carousel.rehydrator = rehydrator;
export default Carousel;
export { rehydrator };